const PasswordValidator = require('password-validator');

const schema = new PasswordValidator();

schema
  .is()
  .min(6)
  .has()
  .uppercase()
  .has()
  .lowercase()
  .has()
  .digits();

export default schema;
